import React from 'react'
import { Link, Navigate } from 'react-router-dom'
import { BaseView, baseStateToProps } from '../smart_bps/lib/base_view'
import { request, wrapView } from '../smart_bps/lib/utils'

/**
 * Раздел «СКУД»: встроенный noVNC (доступ к рабочему столу СКУД).
 * URL noVNC берётся из GET /api/integrations/sigur/status (vnc_url).
 */
class SkudView extends BaseView {
  state = {
    vncUrl: null,
    loading: true,
    enabled: false,
  }

  componentDidMount() {
    request({
      method: 'get',
      url: '/api/integrations/sigur/status',
      success: (data) => {
        this.setState({
          vncUrl: data.vnc_url || null,
          enabled: !!data.enabled,
          loading: false,
        })
      },
      error: () => this.setState({ loading: false }),
    })
  }

  render() {
    if (!this.authorized) {
      return <Navigate to="/auth/login" replace />
    }

    const { vncUrl, loading, enabled } = this.state

    if (loading) {
      return (
        <div className="container py-5">
          <p className="text-muted">Загрузка…</p>
        </div>
      )
    }

    if (!vncUrl) {
      return (
        <div className="container py-5">
          <div className="sigur-chart sigur-chart--integration">
            <h1 className="sigur-chart__title mb-3">Доступ к СКУД</h1>
            <p className="text-muted mb-3">
              {enabled
                ? 'URL noVNC не задан. Укажите переменную окружения SIGUR_VNC_URL (например, адрес контейнера noVNC).'
                : 'Интеграция СКУД отключена. Включите её и настройте SIGUR_VNC_URL для доступа к рабочему столу СКУД.'}
            </p>
            <Link to="/" className="btn btn-outline-secondary">
              На главную
            </Link>
          </div>
        </div>
      )
    }

    return (
      <div className="sigur-skud">
        <div className="sigur-skud__bar">
          <Link to="/" className="btn btn-sm btn-outline-secondary sigur-skud__back">
            ← На главную
          </Link>
          <span className="sigur-skud__title">СКУД (удалённый доступ)</span>
        </div>
        <iframe
          title="СКУД — noVNC"
          src={vncUrl}
          className="sigur-skud__iframe"
        />
      </div>
    )
  }
}

export default wrapView(SkudView, baseStateToProps)
